import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import Icon from '../../components/stateless/Icon';

import { getData } from '../../helpers/postData';

import './index.scss';
import { removeTime } from '../../helpers';

function ProductsBlogSingleItem() {
  const { category, singleItem } = useParams();
  const [news, setNews] = useState([]);
  const categoryName = category === 'companyNews'
    ? 'News'
    : category === 'blog'
      ? 'Blog'
      : category === 'educational'
        ? 'Educational'
        : category;
  const markup = (str) => ({ __html: str });

  useEffect(async () => {
    const { data } = await getData(`/rss-news/${singleItem}`);

    setNews(data);
  }, [getData, singleItem]);

  return (
    news ? <>
      <div className="news-content-wrap">
        <div className="news-content-layout">
          <div className="all-news single-news-content">
            <div className="group-heading-link">
              <Link to="/products-blog">
                <Icon icon="back-icon"/>
                <p className="group-desc-title">All News</p>
              </Link>
              <Icon icon="dot-icon"/>
              <Link to={'/products-blog/' + category}>
                <p className="group-desc-title">{categoryName}</p>
              </Link>
            </div>
            <p className="news-content-title">{news.title}</p>
            <div className="single-news-wrapper">
              <div className="single-news">
                <div className="image-block">
                  <div className="image-block-inner" style={{ backgroundImage: `url("${news.fileUrl}")` }}>
                  </div>
                </div>
                <div className="news-info">
                  <div className="inner-content">
                    <div className="main">
                      <p className="news-content" dangerouslySetInnerHTML={markup(news.description)}/>
                    </div>
                  </div>
                </div>
                <div className="news-views-date">
                  <span className="date">{removeTime(news.updatedAt)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </> : null
  );
}

export default ProductsBlogSingleItem;
